import { createContext } from 'react'

const KanbanColumnStatesContext = createContext()

export default KanbanColumnStatesContext
